// src/app/config/env.js
const normalizedApiUrl = (process.env.REACT_APP_API_URL || "http://localhost:3100").replace(
  /\/+$/,
  ""
);
const normalizedApiPrefix = (process.env.REACT_APP_API_PREFIX || "").replace(
  /^\/+|\/+$/g,
  ""
);

export const env = {
  APP_NAME: process.env.REACT_APP_NAME || "Sabi works",

  // Ej:
  // REACT_APP_API_URL=http://localhost:3100
  // REACT_APP_API_PREFIX=api   (opcional)
  API_URL: normalizedApiUrl,
  API_PREFIX: normalizedApiPrefix,
  API_BASE_URL: normalizedApiPrefix
    ? `${normalizedApiUrl}/${normalizedApiPrefix}`
    : normalizedApiUrl,
  IS_DEV: process.env.NODE_ENV !== "production",
};